import { render, staticRenderFns } from "./job.html?vue&type=template&id=5d5e22a7&scoped=true&"
import script from "./job.js?vue&type=script&lang=js&"
export * from "./job.js?vue&type=script&lang=js&"
import style0 from "./job.scss?vue&type=style&index=0&id=5d5e22a7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e22a7",
  null
  
)

export default component.exports